/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    var datatable = $('#datatable-profit-and-loss'),
        dataTables_buttons = [
            {
                extend: 'csv',
                text: 'Export as CSV',
                exportOptions: {
                    columns: '.data-export'
                },
            },
            {
                extend: 'pdf',
                text: 'Export as PDF',
                exportOptions: {
                    columns: '.data-export'
                },
                orientation: 'landscape'
            },
            {
                extend: 'print',
                text: 'Print table',
                exportOptions: {
                    columns: '.data-export'
                }
            },
            {
                extend: 'colvis'
            }
        ],
        columns = [
            {data: 'name', name: 'name', orderable: true, searchable: true, className: 'data-export'},
            {data: 'company_name', name: 'company_name', orderable: true, searchable: true, className: 'data-export'},
            {data: 'status', name: 'status', orderable: false, searchable: false, className: 'data-export'},
            {data: 'payments', name: 'payments', orderable: false, searchable: false, className: 'data-export'},
            {data: 'expenditures', name: 'expenditures', orderable: false, searchable: false, className: 'data-export'},
            {data: 'profit', name: 'profit', orderable: false, searchable: false, className: 'data-export'},
            {data: 'profit_margin', name: 'profit_margin', orderable: false, searchable: false, className: 'data-export'}
        ],
        $dt;

    $dt = datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "buttons": dataTables_buttons,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/finances/profit-and-loss",
            "method": "POST",
            "data": function ( d ) {
                d.status_id = $('input[name="clickedStatusId"]').val();
                // d.payment_status_id = $('input[name="clickedStatusId"]').val();
                // d.overdue = $('input[name="overdue"]').val();
            }
        },
        "bAutoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": columns,
    });

    $('.js-pl-activity-box').on('click', function() {
        var clickedStatusId = $('input[name="clickedStatusId"]'),
            statusId = $(this).data('status_id');
        clickedStatusId.val(statusId);

        $dt.ajax.reload();
    });
});
